import React from "react";

const SecurityContext = React.createContext({});

export default SecurityContext;